import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { NavBar } from "./Components/layout/NavBar";
import "./styles/styles.css";
import { Hero } from "./Components/pages/Hero";
import { Stack } from "./Components/pages/Stack";
import { Experience } from "./Components/pages/Experience";
import { Projects } from "./Components/pages/Projects";
import { Logs } from "./Components/pages/Logs";
import { Contact } from "./Components/pages/Contact";
import { Footer } from "./Components/layout/Footer";
import Blogs from "./Components/pages/Blogs";
import { ScrollToTop } from "./Components/layout/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <NavBar />
      <Routes>
        <Route path="/blogs" element={<Blogs />} />
        <Route
          path="/"
          element={
            <main>
              <Hero />
              <Stack />
              <Experience />
              <Projects />
              <Logs />
              <Contact />
            </main>
          }
        />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
